import { createStore, combineReducers } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import rawDataTable from "./rawDataTableReducer";

export function createReduxStore(name) {
  const reducers = combineReducers({
    rawDataTable
  });
  const composeEnhancers = composeWithDevTools({ name });
  const middleware = composeEnhancers();
  let store = createStore(reducers, middleware);

  return store;
}
